import { datadogRum } from "@datadog/browser-rum";
import { UserType, type SessionUserData } from "@/types/session";

export const initDataDog = (sessionData?: SessionUserData) => {
  const dataDogEnabled = process.env.NEXT_PUBLIC_DATADOG_ENABLED === "true";
  const dataDogApiKey = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
  if (!dataDogEnabled || !dataDogApiKey) {
    return;
  }

  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID ?? "APPLICATION_ID",
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? "CLIENT_TOKEN",
    site: "datadoghq.com",
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
    env: process.env.NEXT_PUBLIC_DATADOG_ENV,
    version: process.env.NEXT_PUBLIC_DATADOG_VERSION,
    sessionSampleRate: 80,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    silentMultipleInit: true,
    allowedTracingUrls: [
      "https://games.cookunity.com",
      "https://games.qa.cookunity.com",
    ],
    trackSessionAcrossSubdomains: true,
  });

  if (sessionData) {
    datadogRum.setUser({
      id: sessionData.userData?.id?.toString?.(),
      email: sessionData.email,
      is_subs_user: sessionData.userType === UserType.SUBS,
    });
  }

  // datadogRum.startSessionReplayRecording();
};
